import { render } from "./AProposComponent.vue?vue&type=template&id=4d08ae11&scoped=true"
import script from "./AProposComponent.vue?vue&type=script&lang=js"
export * from "./AProposComponent.vue?vue&type=script&lang=js"

import "./AProposComponent.vue?vue&type=style&index=0&id=4d08ae11&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d08ae11"]])

export default __exports__